import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import RoleService from '@iso/services/AccountService/RoleService';

function* viewRole({ id }) {
    try {
        const response = yield call(RoleService.getOne, id);
        yield put(actions.viewRoleSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewRoleFailed(extractError(error)));
    }
}

function* watchViewRole() {
    yield takeEvery(
        types.REQUEST_VIEW_ROLE,
        viewRole,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewRole),
    ]);
}

export default viewSaga;
